import moment from "moment";

export default class AdditionalFieldContent {
    id;
    language;

    label;
    extra_info_website;
    help_text;
    prefix_choices;
    suffix_choices;
    url_link_text;

    static fromJson = (json) => {
        let content = new AdditionalFieldContent();

        content.id = json.id;
        content.language = json.language;

        content.label = json.label;
        content.extra_info_website = json.extra_info_website;
        content.help_text = json.help_text;
        content.prefix_choices = json.prefix_choices;
        content.suffix_choices = json.suffix_choices;
        content.url_link_text = json.url_link_text;

        content.updated_at = json.updated_at ? moment(json.updated_at) : null;
        content.updated_by = json.updated_by;

        return content;
    }
}